export default __webpack_public_path__ + "static/media/page-two.c17dd217.jpeg";